import React, { useEffect, useState } from "react";
import { usePoints } from "../../../app/context/PointsContext";
import style from "./PointsDisplay.module.scss";

export const PointsDisplay = () => {
	const { points } = usePoints();
	const [displayPoints, setDisplayPoints] = useState(0);
	const [isVisible, setIsVisible] = useState(false);

	// biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
	useEffect(() => {
		if (points > displayPoints) {
			setIsVisible(true);
			let start = displayPoints;
			const end = points;
			const duration = 1000;
			const stepTime = Math.abs(Math.floor(duration / (end - start)));

			const timer = setInterval(() => {
				start++;
				setDisplayPoints(start);
				if (start === end) {
					clearInterval(timer);
					// Hide after 2 seconds
					setTimeout(() => setIsVisible(false), 2000);
				}
			}, stepTime);

			return () => clearInterval(timer);
		}
	}, [points]);

	return (
		<div className={`${style.pointsDisplay} ${isVisible ? style.visible : ""}`}>
			<span className={style.plusSign}>+</span>
			{displayPoints}
		</div>
	);
};
